import { TranslationType, type TranslationModel } from "~/common/types/TranslationModel";

interface LinearProductDescriptions {
  description: string;
  shortDescription: TranslationModel;
}

export function getLinearProductDescriptions(
  description: string,
  translate: (value: string) => string,
): LinearProductDescriptions {
  return {
    description: "",
    shortDescription: {
      type: TranslationType.RAW_TEXT,
      value: translate(description),
    },
  };
}
